module.exports = __webpack_public_path__ + "img/38764-337.5d5fbd20.jpg";